import React from 'react';
import './StartMenu.css';

const StartMenu = ({ onStartNew, onLoadGame, onOpenSettings, onOpenTutorial, hasSave }) => {
  return (
    <div className="startmenu-overlay">
      <div className="startmenu">
        <div className="startmenu-logo" aria-hidden="true"></div>
        <h1 className="startmenu-title">Tenfinity</h1>
        <p className="startmenu-tagline">Fill the grid. Clear the lines.</p>

        <nav className="startmenu-actions" aria-label="Game menu">
          <button
            className="startmenu-btn startmenu-btn--primary"
            onClick={onStartNew}
            autoFocus
          >
            Start New Game
          </button>

          {hasSave && (
            <button className="startmenu-btn" onClick={onLoadGame}>
              Continue
            </button>
          )}

          <button className="startmenu-btn" onClick={onOpenTutorial}>
            How to Play
          </button>

          <button className="startmenu-btn startmenu-btn--muted" onClick={onOpenSettings}>
            Settings
          </button>
        </nav>

        <p className="startmenu-footer">Part of Ashtin's Arcade</p>
      </div>
    </div>
  );
};

export default StartMenu;
